import { readOrganizationTwilioRegistrations } from '@usehatchapp/javascript-sdk';
import camelcaseKeys from 'camelcase-keys';
import validateSchema from 'utils/validateSchema';

import { constants } from '../constants';
import { twilioRegistrationsSchema } from '../schema';

export const doReadOrganizationTwilioRegistrations =
  ({ organizationIDs } = {}) =>
  async ({ dispatch, request }) => {
    const {
      READ_ORGANIZATION_TWILIO_REGISTRATIONS_FAILURE,
      READ_ORGANIZATION_TWILIO_REGISTRATIONS_REQUEST,
      READ_ORGANIZATION_TWILIO_REGISTRATIONS_SUCCESS,
    } = constants;

    try {
      // tell state we're fetching twilio registrations
      dispatch({ type: READ_ORGANIZATION_TWILIO_REGISTRATIONS_REQUEST });

      const twilioRegistrations = {};
      const twilioRegistrationsRequests = organizationIDs.map(
        (organizationId) =>
          request(readOrganizationTwilioRegistrations, {
            organizationId,
          }).then((res) => {
            twilioRegistrations[organizationId] = camelcaseKeys(
              validateSchema({
                payload: res,
                schema: twilioRegistrationsSchema,
              }),
            );
          }),
      );

      await Promise.all(twilioRegistrationsRequests);

      // reduce organization payload into store
      dispatch({
        payload: { twilioRegistrations },
        type: READ_ORGANIZATION_TWILIO_REGISTRATIONS_SUCCESS,
      });
    } catch (error) {
      dispatch({ error, type: READ_ORGANIZATION_TWILIO_REGISTRATIONS_FAILURE });
    }
  };
